import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import Alert from 'react-s-alert';
import { delay } from 'lodash';
import { PatientRecordDurationDataList, isRecordDurationRenderTrue, isRecordDurationStart, SavePatientRecordDurationData } from '../../actions/BehaviourDataActions';
import Loader from '../../../../../../../../img/loader.gif';
// import Timer from '../Timer'
import Timer from './Timer';
import RecordDurationDataViewModal from './RecordDurationDataViewModal';
import { alertConfirmation } from '../../../../../../../../actions/utilAction';
import DurationGraphModal from '../../DurationGraphModal';
import { MAX_DURATION_TIME } from '../../constants/TimerConstants';

class RecordDuration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            FromDate: new Date(),
            isStart: props.isStart,
            isSave: props.isSave,
            secondsElapsed: props.secondsElapsed,
            incrementer: props.incrementer,
            todayRecordDurationDataViewModal: false,
            Id: [],
            DoNotZeroOut: [],
            durationGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
            recordingTypeName:'Duration'
        }
    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    componentWillMount = () => {
        // if (this.props.isRecordDurationRenderFlagTrue) {
        //     this.props.PatientRecordDurationDataList(this.state.patientId);
        // }
        this.props.PatientRecordDurationDataList(this.state.patientId);
    }

    componentDidMount = () => {
        if (this.props.recordDurationDataList.data !== undefined) {
            let Id = this.state.Id, DoNotZeroOut = this.state.DoNotZeroOut;
            let patientBehaviorsRateData = this.props.recordDurationDataList.data.PatientBehaviorsReductionData;
            patientBehaviorsRateData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            patientBehaviorsRateData.map((obj, index) => {
                return DoNotZeroOut[index] = obj.doNotZeroOut;
            })
            this.setState({
                Id: Id, DoNotZeroOut: DoNotZeroOut
            })
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.recordDurationDataList.data !== undefined && this.props.isRecordDurationRenderFlagTrue) {
            let clikcedData = this.state.isStart;
            let saveData = this.state.isSave;
            let counterData = this.state.secondsElapsed; 
            

            let patientBehaviorsReductionData = nextProps.recordDurationDataList.data.PatientBehaviorsReductionData;
            let flag1 = nextProps.isSave.some(v=>v===true);
            let flag2 = nextProps.isStart.some(v=>v===true);

            
            
            let myFlag = counterData.some(c=>c>0);
            if(!myFlag){
                patientBehaviorsReductionData.forEach((obj, index) => {
                    counterData[index] = 0;
                })
            }


            if(!flag1){
                patientBehaviorsReductionData.forEach((obj, index) => {
                    saveData[index] = false;
                })
                
            }else{
                saveData = nextProps.isSave;
                clikcedData = nextProps.isStart;
                counterData = nextProps.secondsElapsed.length ? nextProps.secondsElapsed: counterData;
            }
            if(!flag2){
                patientBehaviorsReductionData.forEach((obj, index) => {
                    clikcedData[index] = false;
                });
            }else{
                clikcedData = nextProps.isStart;
                counterData = nextProps.secondsElapsed.length ? nextProps.secondsElapsed: counterData;
            }
            this.setState({
                isStart: clikcedData,
                isSave: saveData,
                secondsElapsed: counterData,
            })
        }

        if (nextProps.recordDurationDataList.data !== undefined) {
            let Id = this.state.Id, DoNotZeroOut = this.state.DoNotZeroOut;
            let patientBehaviorsRateData = nextProps.recordDurationDataList.data.PatientBehaviorsReductionData;
            patientBehaviorsRateData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            patientBehaviorsRateData.map((obj, index) => {
                return DoNotZeroOut[index] = obj.doNotZeroOut;
            })
            this.setState({
                Id: Id, DoNotZeroOut: DoNotZeroOut
            })
        }
    }


    componentWillUnmount = () => {
        this.props.isRecordDurationRenderTrue(false)
    }

    handleClose = () => {
        this.setState({
            todayRecordDurationDataViewModal: false,
            durationGraphModalOpen: false,
            modalTitle: '',
            behaviorsReductionId: -1
        })
    }

    onGraphHandler(e,obj){
        e.preventDefault();
        this.setState({
            durationGraphModalOpen: true,
            modalTitle: obj.behaviorName,
            behaviorsReductionId: obj.id
        })
    }


    todayRecordDurationDataView = () => {
        this.setState({
            todayRecordDurationDataViewModal: true
        })

    }

    handleStart = (index) => {
        this.props.isRecordDurationStart(index, true)
        let isStart = this.state.isStart
        isStart[index] = true
        this.setState({
            isStart: isStart
        });
    }

    handleStop = (index) => {
        let isStart = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        isStart[index] = false
        isSave[index] = true
        counterData[index];
        this.setState({
            isStart: isStart,
            isSave: isSave,
            secondsElapsed: counterData
        }, () => {clearInterval(this.state.incrementer[index]), clearInterval(this.props.newIncrementer[index])});
    }

    handleCancel = (index) => {
        Alert.closeAll()
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        clikcedData[index] = false
        isSave[index] = false
        counterData[index] = 0;
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData
        },() => {clearInterval(this.state.incrementer[index]), clearInterval(this.props.newIncrementer[index]) });

    }

    handleCancelConfirmation = (index) => {
        alertConfirmation('Are you sure you want to cancel Duration Details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: () => this.handleCancel(index),
            }
        });
    }

    /////////////////////////////////

    saveData = ({seconds,id}) => {
        Alert.closeAll()
        let value = seconds >= MAX_DURATION_TIME? MAX_DURATION_TIME: seconds;

        let mins = Math.floor(value / 60);
        let secs = Math.floor(value % 60);
        if (secs < 10) {
            secs = `0${secs}`
        }
        let duration = mins+"."+secs


        let postData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            // "patientRecordDurationDataDetailsModel": [],
            "patientRecordDurationDataDetailsModel": [
                {
                    "recordDurationDataDetailId": 0,
                    "recordDurationDataId": 0,
                    "behaviorsReductionId": id,
                    "duration": duration
                }
            ]
        }
        // console.log("postData",postData);
        this.props.SavePatientRecordDurationData(postData)
        delay(()=>this.props.PatientRecordDurationDataList(this.state.patientId),200)
    }


    /////////////////////////////////

    handleSave = (id, index) => {
        let minutes = Math.floor(this.props.secondsElapsed[index] / 60);
        let seconds = Math.floor(this.props.secondsElapsed[index] % 60);
        if (seconds < 10) {
            seconds = `0${seconds}`
        }
        let duration = minutes+"."+seconds
        let finalData = [];
        this.state.Id.map((obj, i) => {   
            if(index === i) {
                let patientRecordFrequencyDataDetailsModelData = {
                    "recordDurationDataDetailId": 0,
                    "recordDurationDataId": 0,
                    "behaviorsReductionId": id,
                    "duration": duration
                }
                finalData.push(patientRecordFrequencyDataDetailsModelData);
            }
            else {
                if(this.state.DoNotZeroOut[i] === true) {
                    let patientRecordFrequencyDataDetailsModelData = {
                        "recordDurationDataDetailId": 0,
                        "recordDurationDataId": 0,
                        "behaviorsReductionId": obj,
                        "duration": 0
                    }
                    finalData.push(patientRecordFrequencyDataDetailsModelData);
                }
            }
        });

        let postData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            "patientRecordDurationDataDetailsModel": finalData,
            // "patientRecordDurationDataDetailsModel": [
            //     {
            //         "recordDurationDataDetailId": 0,
            //         "recordDurationDataId": 0,
            //         "behaviorsReductionId": id,
            //         "duration": duration
            //     }
            // ]
        }
        this.props.SavePatientRecordDurationData(postData)
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        counterData[index] = 0;
        clikcedData[index] = false
        isSave[index] = false
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData
        },() => {clearInterval(this.state.incrementer[index]), clearInterval(this.props.newIncrementer[index])});
    }

    getSeconds = (index) => {
        return ('0' + this.state.secondsElapsed[index] % 60).slice(-2)
    }

    getMinutes = (index) => {
        return Math.floor(this.state.secondsElapsed[index] / 60)
    }


    renderData = (dataList) => {
        let PatientRecordDurationData = dataList || [];
        if (!PatientRecordDurationData.length) {
            return (
                <tr>
                    <td>
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientRecordDurationData.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td  width="30%">
                        {Obj.behaviorName}
                        {/* <div className="row">
                            <div className="col-sm-12 btn_lt reset-btn mt-10">
                                {(this.state.isStart[index] === false && this.state.isSave[index] === false) &&
                                    <RaisedButton
                                        label="START"
                                        className='startButton'
                                        primary={true}
                                        onTouchTap={() => this.handleStart(index)} />
                                }
                                {(this.state.isStart[index] === true && this.state.isSave[index] === false) &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="STOP"
                                                className='stopButton'
                                                primary={true}
                                                onTouchTap={() => this.handleStop(index)} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'                                                
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation(index)} />
                                        </span>
                                    </div>
                                }
                                {this.state.isSave[index] === true &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="SAVE"
                                                primary={true}
                                                onTouchTap={() => this.handleSave(Obj.id, index)} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation(index)} />
                                        </span>
                                    </div>
                                }
                            </div>
                        </div> */}
                    </td>
                    <td  width="30%">
                        {Obj.description}
                    </td>
                    <td style={{textAlign:"center"}}  width="20%">
                        {/* {this.getMinutes(index)}:{this.getSeconds(index)} */}
                        {/* {this.state.isStart[index] || this.state.isSave[index] ? <Timer index={index} isForcedLogout={this.props.isForcedLogout} /> : '0:00'} */}
                        {this.props.addPermissionBehavior && <Timer getPatientRecordDurationDataList = {this.props.PatientRecordDurationDataList}  PatientBehaviorsReductionData = {this.props.recordDurationDataList.data.PatientBehaviorsReductionData} id={Obj.id} userID={this.props.userID} patientID={this.props.patientID} submitData={(data)=>this.saveData(data)}/>}
                    </td>
                    <td  width="20%">
                        {/* {(this.state.targetType && this.state.targetType[index])?( */}
                            <button type="button" onClick={(e) => this.onGraphHandler(e,Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                        {/* ):''} */}
                    </td>  
                </tr>
            )
        })
    }

    renderRecordDuration = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordDurationDataList } = this.props;
        let PatientRecordDurationList = (recordDurationDataList && recordDurationDataList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="30%">Duration</th>
                            <th width="30%">Operational Definition</th>
                            <th width="30%"></th>
                            <th width="10%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(PatientRecordDurationList.PatientBehaviorsReductionData)}
                    </tbody>
                </table>
            </div>
        )
    }


    render() {

        return (
            <div>
                {this.renderLoading()}

                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter">
                                <RaisedButton
                                    style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                    className="ml_15"
                                    onClick={() => this.todayRecordDurationDataView()}
                                    label="Today's Duration Data"
                                    primary={true}>
                                </RaisedButton>
                            </div>
                            {this.renderRecordDuration()}
                            {
                                this.state.durationGraphModalOpen &&
                                <DurationGraphModal
                                    patientId={this.state.patientId}
                                    closeDialog={() => this.handleClose()}
                                    recordingTypeName={this.state.recordingTypeName}
                                    behaviorsReductionId={this.state.behaviorsReductionId}
                                    modalTitle={this.state.modalTitle}
                                />
                            }
                        </div>
                    </div>
                    <div>
                        {
                            this.state.todayRecordDurationDataViewModal && <RecordDurationDataViewModal
                                patientId={this.state.patientId}
                                creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                                uuid={this.props.uuid}
                                closeDialog={() => this.handleClose()}
                                updatePermissionBehavior = {this.props.updatePermissionBehavior}
                                 deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

RecordDuration = reduxForm({
    form: 'RecordDurationForm',
    enableReinitialize: true,
})(RecordDuration);

function mapStateToProps(state) {
    return {
        loading: state.patientBehaviourData.loading,
        recordDurationDataList: state.patientBehaviourData.recordDurationDataList !== null ? state.patientBehaviourData.recordDurationDataList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,
        userID: state.login.loginUserInfo.userID,
        patientID: state.patient.patientInfo.PatientID,
        isRecordDurationRenderFlagTrue: state.patientRecordDurationCustomReducer.isRecordDurationRenderTrue,
        isStart: state.patientRecordDurationCustomReducer.isStart,
        isSave: state.patientRecordDurationCustomReducer.isSave,
        secondsElapsed: state.patientRecordDurationCustomReducer.secondsElapsed,
        incrementer: state.patientRecordDurationCustomReducer.incrementer,
        newIncrementer: state.patientRecordDurationCustomReducer.newIncrementer,
        isForcedLogout: state.login.isForcedLogout
    }
}

export default connect(mapStateToProps, { PatientRecordDurationDataList, isRecordDurationRenderTrue, isRecordDurationStart, SavePatientRecordDurationData })(RecordDuration);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordDuration/RecordDuration.js